export default (props, vars) => {
  const applicationOffer = vars?.useapplicationoffer2?.applicationOffer;
  if (!applicationOffer) return '';

  const { end_date } = applicationOffer;
  return end_date ? `End Date: ${end_date}` : '';
};
